
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTop from '../../components/feature/ScrollToTop';
import AnimatedSection from '../../components/base/AnimatedSection';

export default function Portfolio() {
  const [activeFilter, setActiveFilter] = useState('الكل');

  const categories = ['الكل', 'إعلانات', 'وثائقيات', 'فعاليات', 'موشن جرافيك', 'تصوير فوتوغرافي'];

  const portfolioItems = [
    {
      id: 1,
      title: 'إعلان تجاري - شركة التقنية المتقدمة',
      category: 'إعلانات',
      client: 'شركة التقنية المتقدمة',
      year: '2024',
      duration: '60 ثانية',
      description: 'إعلان تجاري متطور يعرض خدمات الشركة التقنية بأسلوب إبداعي وجذاب',
      image: 'https://public.readdy.ai/ai/img_res/515b6009ad21e6a2d79e8585ad69aa67.jpg',
      tags: ['إعلان تجاري', 'تقنية', 'شركات']
    },
    {
      id: 2,
      title: 'فيلم وثائقي - التراث السعودي',
      category: 'وثائقيات',
      client: 'وزارة الثقافة',
      year: '2024',
      duration: '25 دقيقة',
      description: 'فيلم وثائقي يستكشف جمال التراث السعودي الأصيل وتاريخه العريق',
      image: 'https://readdy.ai/api/search-image?query=Documentary%20film%20about%20Saudi%20Arabian%20heritage%20featuring%20traditional%20architecture%2C%20desert%20landscapes%2C%20cultural%20artifacts%2C%20and%20historical%20sites%20with%20cinematic%20quality%20and%20cultural%20authenticity&width=600&height=400&seq=19&orientation=landscape',
      tags: ['وثائقي', 'تراث', 'ثقافة']
    },
    {
      id: 3,
      title: 'تغطية مؤتمر الرياض للتقنية',
      category: 'فعاليات',
      client: 'مؤسسة الرياض للتقنية',
      year: '2024',
      duration: 'يوم كامل',
      description: 'تغطية شاملة لمؤتمر التقنية الأكبر في المنطقة مع بث مباشر',
      image: 'https://readdy.ai/api/search-image?query=Technology%20conference%20coverage%20in%20Riyadh%20with%20modern%20venue%2C%20speakers%20on%20stage%2C%20audience%2C%20professional%20cameras%2C%20and%20live%20streaming%20setup%20in%20contemporary%20Saudi%20Arabian%20event&width=600&height=400&seq=20&orientation=landscape',
      tags: ['مؤتمر', 'تقنية', 'بث مباشر']
    },
    {
      id: 4,
      title: 'حملة إعلانية - مهرجان الثقافة',
      category: 'إعلانات',
      client: 'هيئة الترفيه',
      year: '2023',
      duration: '30 ثانية',
      description: 'حملة إعلانية متكاملة لمهرجان الثقافة السعودي بتصاميم إبداعية',
      image: 'https://readdy.ai/api/search-image?query=Cultural%20festival%20advertising%20campaign%20with%20vibrant%20colors%2C%20traditional%20Saudi%20elements%2C%20artistic%20performances%2C%20and%20modern%20design%20showcasing%20Saudi%20Arabian%20cultural%20celebration&width=600&height=400&seq=21&orientation=landscape',
      tags: ['مهرجان', 'ثقافة', 'حملة إعلانية']
    },
    {
      id: 5,
      title: 'موشن جرافيك - شرح الخدمات المصرفية',
      category: 'موشن جرافيك',
      client: 'بنك الراجحي',
      year: '2024',
      duration: '2 دقيقة',
      description: 'فيديو موشن جرافيك يشرح الخدمات المصرفية الرقمية بطريقة مبسطة',
      image: 'https://readdy.ai/api/search-image?query=Motion%20graphics%20animation%20for%20banking%20services%20with%20modern%203D%20elements%2C%20financial%20icons%2C%20digital%20interfaces%2C%20and%20clean%20design%20representing%20Saudi%20Arabian%20banking%20sector&width=600&height=400&seq=22&orientation=landscape',
      tags: ['موشن جرافيك', 'مصرفي', 'تعليمي']
    },
    {
      id: 6,
      title: 'جلسة تصوير - مجموعة الأزياء الراقية',
      category: 'تصوير فوتوغرافي',
      client: 'دار الأزياء الملكية',
      year: '2024',
      duration: 'يوم واحد',
      description: 'جلسة تصوير فوتوغرافي راقية لمجموعة الأزياء الجديدة',
      image: 'https://readdy.ai/api/search-image?query=High-end%20fashion%20photography%20session%20with%20elegant%20models%2C%20luxury%20clothing%2C%20professional%20studio%20lighting%2C%20and%20sophisticated%20Saudi%20Arabian%20fashion%20design%20aesthetic&width=600&height=400&seq=23&orientation=landscape',
      tags: ['تصوير', 'أزياء', 'موضة']
    },
    {
      id: 7,
      title: 'فيديو تعريفي - جامعة الملك سعود',
      category: 'وثائقيات',
      client: 'جامعة الملك سعود',
      year: '2023',
      duration: '5 دقائق',
      description: 'فيديو تعريفي شامل بجامعة الملك سعود وكلياتها المختلفة',
      image: 'https://readdy.ai/api/search-image?query=University%20promotional%20video%20featuring%20modern%20campus%20buildings%2C%20students%2C%20academic%20facilities%2C%20and%20educational%20environment%20at%20King%20Saud%20University%20in%20Saudi%20Arabia&width=600&height=400&seq=24&orientation=landscape',
      tags: ['تعليم', 'جامعة', 'تعريفي']
    },
    {
      id: 8,
      title: 'تغطية حفل الافتتاح - مول الرياض الجديد',
      category: 'فعاليات',
      client: 'مجموعة العقارات المتحدة',
      year: '2024',
      duration: '3 ساعات',
      description: 'تغطية حفل افتتاح مول الرياض الجديد مع ضيوف VIP',
      image: 'https://readdy.ai/api/search-image?query=Grand%20opening%20event%20coverage%20of%20luxury%20shopping%20mall%20in%20Riyadh%20with%20VIP%20guests%2C%20red%20carpet%2C%20modern%20architecture%2C%20and%20professional%20event%20photography%20in%20Saudi%20Arabia&width=600&height=400&seq=25&orientation=landscape',
      tags: ['افتتاح', 'مول', 'فعالية']
    },
    {
      id: 9,
      title: 'إعلان منتج - عطور الشرق',
      category: 'إعلانات',
      client: 'دار العطور الشرقية',
      year: '2024',
      duration: '45 ثانية',
      description: 'إعلان فاخر لمجموعة عطور شرقية أصيلة بلمسة عصرية',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20perfume%20commercial%20with%20elegant%20bottles%2C%20Arabian%20oud%2C%20traditional%20and%20modern%20elements%2C%20sophisticated%20lighting%2C%20and%20premium%20Saudi%20Arabian%20fragrance%20branding&width=600&height=400&seq=26&orientation=landscape',
      tags: ['عطور', 'فخامة', 'تراث']
    }
  ];

  const filteredItems = activeFilter === 'الكل' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === activeFilter);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative pt-20 pb-32 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://readdy.ai/api/search-image?query=Creative%20portfolio%20showcase%20with%20various%20media%20production%20works%2C%20video%20screens%2C%20photography%20displays%2C%20and%20professional%20media%20equipment%20in%20modern%20Saudi%20Arabian%20production%20studio&width=1920&height=1080&seq=27&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 text-center text-white">
          <AnimatedSection animation="fadeIn">
            <h1 className="text-5xl md:text-7xl font-bold mb-6">معرض أعمالنا</h1>
            <p className="text-xl md:text-2xl max-w-4xl mx-auto leading-relaxed">
              استكشف مجموعة من أفضل أعمالنا التي تعكس خبرتنا وإبداعنا في مجال الإنتاج الإعلامي
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <AnimatedSection animation="slideUp">
            <div className="flex flex-wrap justify-center gap-4">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setActiveFilter(category)}
                  className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap ${
                    activeFilter === category
                      ? 'bg-yellow-600 text-white shadow-lg'
                      : 'bg-white text-gray-700 hover:bg-yellow-100 shadow-md'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* Portfolio Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredItems.map((item, index) => (
              <AnimatedSection 
                key={item.id} 
                animation="slideUp" 
                delay={index * 100}
                className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden"
              >
                <div className="relative overflow-hidden">
                  <img 
                    src={item.image} 
                    alt={item.title}
                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-4 left-4 right-4">
                      <div className="flex flex-wrap gap-2 mb-3">
                        {item.tags.map((tag, idx) => (
                          <span key={idx} className="bg-yellow-500 text-black px-2 py-1 rounded-full text-xs font-medium">
                            {tag}
                          </span>
                        ))}
                      </div>
                      <div className="text-white text-sm">
                        <div className="flex items-center gap-4 mb-2">
                          <span className="flex items-center">
                            <i className="ri-time-line mr-1"></i>
                            {item.duration}
                          </span>
                          <span className="flex items-center">
                            <i className="ri-calendar-line mr-1"></i>
                            {item.year}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="absolute top-4 right-4">
                    <span className="bg-yellow-500 text-black px-3 py-1 rounded-full text-sm font-medium">
                      {item.category}
                    </span>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-yellow-600 transition-colors duration-300">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">{item.client}</p>
                  <p className="text-gray-600 leading-relaxed mb-4">{item.description}</p>
                  
                  <div className="flex items-center justify-between">
                    <div className="text-sm text-gray-500">
                      <i className="ri-calendar-line mr-1"></i>
                      {item.year}
                    </div>
                    <button className="text-yellow-600 hover:text-yellow-700 font-medium transition-colors duration-300">
                      عرض التفاصيل
                      <i className="ri-arrow-left-line mr-2"></i>
                    </button>
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="container mx-auto px-4">
          <AnimatedSection animation="slideUp" className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">إنجازاتنا بالأرقام</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              أرقام تتحدث عن مسيرتنا الناجحة وثقة عملائنا بنا
            </p>
          </AnimatedSection>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              { number: '500+', label: 'مشروع مكتمل' },
              { number: '200+', label: 'عميل راضٍ' },
              { number: '50+', label: 'جائزة وتقدير' },
              { number: '8+', label: 'سنوات خبرة' }
            ].map((stat, index) => (
              <AnimatedSection 
                key={index} 
                animation="slideUp" 
                delay={index * 100}
                className="text-center"
              >
                <div className="text-4xl md:text-6xl font-bold text-yellow-500 mb-2">
                  {stat.number}
                </div>
                <div className="text-lg text-gray-300">{stat.label}</div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-yellow-600 to-red-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <AnimatedSection animation="fadeIn">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">أعجبك ما رأيت؟</h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
              دعنا نساعدك في إنشاء مشروع مميز يضاف إلى معرض أعمالنا القادم
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-gray-900 hover:bg-gray-100 px-8 py-4 rounded-xl font-medium transition-all duration-300 whitespace-nowrap">
                ابدأ مشروعك الآن
              </button>
              <button className="bg-red-600 hover:bg-red-700 px-8 py-4 rounded-xl font-medium transition-all duration-300 whitespace-nowrap">
                تواصل معنا
              </button>
            </div>
          </AnimatedSection>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
      <ScrollToTop />
    </div>
  );
}
